import { c as _c } from "react/compiler-runtime";
import { useSphereDialog } from "@components/common/dialog/sphere-dialog-provider";
import { BulkActionListItem } from "@components/common/faro-table/bulk-dialog/content-list/bulk-action-list-item";
import { List, Text } from "@flat-ui";
import { Box, Stack } from "@mui-wrapper";
/** How high the list grows before it scrolls, in theme spacing: as high as that of a bulk dialog */
const LIST_MAX_HEIGHT_SPACING = 25;
/**
 * Returns how to show the people that could not be invited in a dialog rather than a toast, since
 * there can be many of them and the user may need to act on each
 */
export function useInviteFailuresDialog() {
  const $ = _c(2);
  const {
    createDialog
  } = useSphereDialog();
  let t0;
  if ($[0] !== createDialog) {
    t0 = props => {
      createDialog({
        title: props.isAnyInvited ? "Some members could not be invited" : "The members could not be invited",
        confirmText: "OK",
        isHideCancel: true
      }, <InviteFailuresList {...props} />);
    };
    $[0] = createDialog;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}

/**
 * Lists the people that could not be invited, e.g. since they could not be given their Sphere XG
 * seat, and tells what happened to the rest of them
 */
export function InviteFailuresList(t0) {
  const $ = _c(13);
  const {
    failures,
    isAnyInvited,
    areSeatsGiven
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: 1
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = isAnyInvited ? "The other members were invited." : "None of the members were invited.";
  const t3 = areSeatsGiven && " The Sphere XG seats that were assigned stay assigned.";
  let t4;
  if ($[1] !== t2 || $[2] !== t3) {
    t4 = <Text variant="bodyM">{t2}{t3}</Text>;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      maxHeight: _temp,
      overflow: "auto"
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      py: 0
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== failures) {
    t7 = failures.map(_temp2);
    $[6] = failures;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t7) {
    t8 = <Box sx={t5}><List dense={true} sx={t6}>{t7}</List></Box>;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t4 || $[11] !== t8) {
    t9 = <Stack sx={t1}>{t4}{t8}</Stack>;
    $[10] = t4;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
}
function _temp2(t0) {
  const {
    key,
    label,
    reason
  } = t0;
  return <BulkActionListItem key={key} tableDataType="members" item={{
    id: key,
    status: "error",
    message: reason
  }} fallbackLabel={label} />;
}
function _temp(theme) {
  return theme.spacing(LIST_MAX_HEIGHT_SPACING);
}